export const ELEVENLABS_AGENT_ID = "agent_2201m0pwegkjfrp8e0wr7vc6npbq";
export const ELEVENLABS_WIDGET_SCRIPT =
  "https://unpkg.com/@elevenlabs/convai-widget-embed";

export const ELEVENLABS_WIDGET_PATHS = ["/", "/pricing", "/free-tools"] as const;

export function shouldLoadElevenLabsWidget(pathname: string): boolean {
  const rawPath = pathname.split(/[?#]/, 1)[0] || "/";
  const normalizedPath = rawPath === "/" ? rawPath : rawPath.replace(/\/+$/, "");
  return ELEVENLABS_WIDGET_PATHS.some(path => path === normalizedPath);
}
